import { Stack, Typography } from "@mui/material";
import { TEXT_PRIMARY_DARK, TEXT_SECONDARY } from "@/config/mui/colorPalette";
import {
  generatePackageItemOnlineStoreAmount,
  generatePackageItemOnlineStoreName,
} from "@/utils/packages";
import { MedspaPackage } from "@/views/online-store/onlineStoreView";

export type PackageItemLineType = MedspaPackage["packageItems"][number];

type PackageItemLineProps = {
  item: PackageItemLineType;
  size?: "small" | "medium";
};

export default function PackageItemLine({
  item,
  size = "small",
}: PackageItemLineProps) {
  const typographyVariant = size === "small" ? "labelTiny" : "labelSmall";

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography
        variant={typographyVariant}
        sx={{
          color: TEXT_PRIMARY_DARK,
        }}
      >
        {generatePackageItemOnlineStoreName(item)}
      </Typography>
      <Typography
        variant={typographyVariant}
        sx={{
          color: TEXT_SECONDARY,
        }}
      >
        {generatePackageItemOnlineStoreAmount(item)}
      </Typography>
    </Stack>
  );
}
